var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import { nanoid } from "nanoid";
// stylesheets
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/summary.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/Accordion/accordion.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
//components
import FundSearchPanel from "@frameworks/shared-library/components/Generic/FundSeachPanel/FundSearchPanel";
import VerticalFilterTabs from "@frameworks/shared-library/components/VerticalFilterTabs/VerticalFilterTabs";
import Checkbox from "./Checkbox";
import InputComponent from "../InputComponent";
import BasicErrorMessage from "@frameworks/shared-library/components/BasicErrorMessage/BasicErrorMessage";
// helpers
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import CustomSelect from "./CustomSelect";
import { FieldNames } from "../../constants/constant";
import ClientNamesWithCodes from "../../components/ClientNameWithCodes/ClientNamesWithCodes";
var SummaryFiltersOrderbook = function (props) {
    //
    var _a = __read(React.useState([]), 2), localClientsList = _a[0], setLocalClientsList = _a[1];
    var _b = __read(React.useState(""), 2), searchedClient = _b[0], setSearchedClient = _b[1];
    var _c = __read(React.useState([]), 2), filterTabs = _c[0], setFilterTabs = _c[1];
    var _d = __read(React.useState(props.requestPayload == ESubProductIds.AIF
        ? FieldNames.CATEGORY
        : FieldNames.AMCNAME), 2), activeTabKey = _d[0], setActiveTabKey = _d[1];
    var _e = useSelector(function (state) { return state.markets.AifPms; }), filterDetailsAmc = _e.filterDetailsAmc, filterDetailsFund = _e.filterDetailsFund, filterDetailsCategory = _e.filterDetailsCategory, filterListAIFFundName = _e.filterListAIFFundName;
    var filterListFundName = useSelector(function (state) { return state.markets.AifPms; }).filterListFundName;
    var _f = __read(useState({
        conditionType: {
            conditionType: { label: "Above", value: "Above" },
            conditionValue: "",
        },
        returnExpectation: {
            returnExpectation: { label: "Above", value: "Above" },
            conditionValue: "",
        },
        drawdown: {
            drawdown: { label: "Above", value: "Above" },
            conditionValue: "",
        },
        amcNameList: [],
        fundManagerList: [],
        categoryNameList: [],
        fundNameList: [],
    }), 2), aumsize = _f[0], setAumSize = _f[1];
    var updateSelectAumSize = function (keyName, value) {
        var _a, _b;
        setAumSize(__assign(__assign({}, aumsize), (_a = {}, _a[keyName] = __assign(__assign({}, aumsize[keyName]), (_b = {}, _b[keyName] = value, _b)), _a)));
    };
    var updateInputAumSize = function (keyName, event) {
        setAumSize(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[keyName] = __assign(__assign({}, prevState[keyName]), { conditionValue: event.target.value }), _a)));
        });
    };
    var generateFilterInputForClients = function (keyName, placeholder) {
        var _a, _b, _c, _d, _e;
        var selectedValue = keyName == "conditionType"
            ? (_b = (_a = aumsize === null || aumsize === void 0 ? void 0 : aumsize[keyName]) === null || _a === void 0 ? void 0 : _a[keyName]) === null || _b === void 0 ? void 0 : _b.value
            : (_d = (_c = aumsize === null || aumsize === void 0 ? void 0 : aumsize[keyName]) === null || _c === void 0 ? void 0 : _c[keyName]) === null || _d === void 0 ? void 0 : _d["value"];
        return (React.createElement("div", { className: "summary aif-pms-order-book mt-4 mx-2" },
            React.createElement(CustomSelect, { updateSelectAumSize: function (option) {
                    updateSelectAumSize(keyName, option);
                }, selectedValue: selectedValue }),
            React.createElement(InputComponent, { label: "", placeholder: placeholder, helperText: "", integer: true, value: (_e = aumsize === null || aumsize === void 0 ? void 0 : aumsize[keyName]) === null || _e === void 0 ? void 0 : _e["conditionValue"], onChangeEvent: function (event) {
                    return updateInputAumSize(keyName, event);
                }, name: placeholder.includes("amount") ? "amount" : "percentage" })));
    };
    var generateCheckbox = function (filtersData, selectedDataArr, placeholder, keyName) {
        var catCount = filtersData === null || filtersData === void 0 ? void 0 : filtersData.length;
        if (keyName == FieldNames.CATEGORY) {
            catCount = (filtersData === null || filtersData === void 0 ? void 0 : filtersData.length) > 0 ? filtersData[0].count : 0;
        }
        var data = __spreadArray([
            {
                filterId: keyName == FieldNames.CATEGORY ? "all" : "All (".concat(catCount, ")"),
                name: keyName == FieldNames.CATEGORY ? "All (".concat(catCount, ")") : "all",
                filter_value: "All",
            }
        ], __read(filtersData), false);
        return (React.createElement("div", { className: "client-names-radio-filters-container summary" },
            React.createElement("div", { className: "d-flex flex-column justify-content-center" }, (data === null || data === void 0 ? void 0 : data.length) ? (data.map(function (item) {
                var isCategory = keyName === FieldNames.CATEGORY;
                var isFundName = keyName === FieldNames.FUND_NAME_CAP;
                var filterValue = isCategory ? item.filterId : item.name;
                var displayValue = isCategory
                    ? item.name
                    : isFundName
                        ? item === null || item === void 0 ? void 0 : item.filterId
                        : item.filterId;
                var isSelected = selectedDataArr === null || selectedDataArr === void 0 ? void 0 : selectedDataArr.includes(filterValue);
                return (React.createElement(Checkbox, { key: nanoid(), list: {
                        display: displayValue,
                        value: filterValue,
                    }, checkboxType: "han-blue", parentClassName: "orderbook-summary-checkbox-filter", checkboxProps: {
                        checked: isSelected,
                        value: filterValue,
                        onChange: function (e) {
                            return handleCheckboxChange(e, keyName, filtersData);
                        },
                    }, labelProps: {
                        children: displayValue,
                    } }));
            })) : (React.createElement(BasicErrorMessage, { primaryText: "No results found!", subText: "Try searching for something else or explore other options." })))));
    };
    var generateCheckboxFiltersForClients = function (filtersData, selectedDataArr, placeholder, keyName) {
        //
        var generateMatchingName = function (text) {
            if (!searchedClient)
                return text;
            var parts = text.split(new RegExp("(".concat(searchedClient, ")"), "gi"));
            return parts.map(function (part, index) {
                return part.toLowerCase() === searchedClient.toLowerCase() ? (React.createElement("b", { key: index, className: "DMSansMedium_12_500" }, part)) : (part);
            });
        };
        return (React.createElement("div", { className: "client-names-radio-filters-container summary" },
            React.createElement(FundSearchPanel, { placeholder: placeholder, applySearchedFilters: function (value) {
                    setSearchedClient(value);
                }, searchValue: searchedClient, autoComplete: "off" }),
            React.createElement("div", { className: "d-flex flex-column justify-content-center" }, (filtersData === null || filtersData === void 0 ? void 0 : filtersData.length) ? (filtersData.map(function (item) {
                var value = keyName === FieldNames.FUNDMANAGER ? item.filterId : item.name;
                var checked = keyName === FieldNames.FUNDMANAGER
                    ? selectedDataArr === null || selectedDataArr === void 0 ? void 0 : selectedDataArr.includes(item.filterId)
                    : selectedDataArr === null || selectedDataArr === void 0 ? void 0 : selectedDataArr.includes(item.name);
                return (React.createElement(Checkbox, { key: nanoid(), list: {
                        display: (React.createElement(ClientNamesWithCodes, { clientName: item.filterId, clientCode: item.name, wrapClientName: true, searchText: searchedClient, generateMatchingName: generateMatchingName })),
                        value: item.name,
                    }, checkboxType: "han-blue", parentClassName: "orderbook-summary-checkbox-filter", checkboxProps: {
                        checked: checked,
                        value: value,
                        onChange: function (e) { return handleCheckboxChange(e, keyName); },
                    }, labelProps: { children: item.filterId } }));
            })) : (React.createElement(BasicErrorMessage, { primaryText: "No results found!", subText: "Try searching for something else or explore other options." })))));
    };
    var generateFiltersLoaderOrErrorUI = function (loader, dataForFilterFunction, filterUIGeneratorFunction, optional) {
        if (loader) {
            return (React.createElement("div", { className: "d-flex align-items-center justify-content-center h-100" },
                React.createElement(Spinner, { animation: "border", variant: "primary" })));
        }
        else {
            return (dataForFilterFunction === null || dataForFilterFunction === void 0 ? void 0 : dataForFilterFunction.length) ? (filterUIGeneratorFunction()) : optional ? (React.createElement("div", { className: "d-flex align-items-center h-100" },
                React.createElement(BasicErrorMessage, { primaryText: "No results found!" }))) : (filterUIGeneratorFunction());
        }
    };
    var handleCheckboxChange = function (e, keyName, filtersData) {
        var _a, _b, _c;
        var _d = e.target, value = _d.value, checked = _d.checked;
        if (activeTabKey === FieldNames.AMCNAME) {
            var updatedSelectedCheckboxes = aumsize === null || aumsize === void 0 ? void 0 : aumsize.amcNameList;
            if (value === "all") {
                var filter = filtersData === null || filtersData === void 0 ? void 0 : filtersData.map(function (item) {
                    return item.name;
                });
                updatedSelectedCheckboxes = checked ? __spreadArray(["all"], __read(filter), false) : [];
            }
            else {
                if (checked) {
                    updatedSelectedCheckboxes === null || updatedSelectedCheckboxes === void 0 ? void 0 : updatedSelectedCheckboxes.push(value);
                }
                else {
                    updatedSelectedCheckboxes = (_a = aumsize === null || aumsize === void 0 ? void 0 : aumsize.amcNameList) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item !== value; });
                }
            }
            setAumSize(__assign(__assign({}, aumsize), { amcNameList: updatedSelectedCheckboxes }));
        }
        if (activeTabKey === FieldNames.FUND_NAME_CAP) {
            var updatedSelectedCheckboxes = aumsize === null || aumsize === void 0 ? void 0 : aumsize.fundNameList;
            if (value === "all") {
                var filter = filtersData === null || filtersData === void 0 ? void 0 : filtersData.map(function (item) {
                    return item.name;
                });
                updatedSelectedCheckboxes = checked ? __spreadArray(["all"], __read(filter), false) : [];
            }
            else {
                if (checked) {
                    updatedSelectedCheckboxes === null || updatedSelectedCheckboxes === void 0 ? void 0 : updatedSelectedCheckboxes.push(value);
                }
                else {
                    updatedSelectedCheckboxes = (_b = aumsize === null || aumsize === void 0 ? void 0 : aumsize.fundNameList) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return item !== value; });
                }
            }
            setAumSize(__assign(__assign({}, aumsize), { fundNameList: updatedSelectedCheckboxes }));
        }
        if (activeTabKey === FieldNames.FUNDMANAGER) {
            var updatedSelectedCheckboxes = aumsize === null || aumsize === void 0 ? void 0 : aumsize.fundManagerList;
            if (checked) {
                updatedSelectedCheckboxes === null || updatedSelectedCheckboxes === void 0 ? void 0 : updatedSelectedCheckboxes.push(value);
            }
            else {
                updatedSelectedCheckboxes = aumsize === null || aumsize === void 0 ? void 0 : aumsize.fundManagerList.filter(function (item) { return item !== value; });
            }
            setAumSize(__assign(__assign({}, aumsize), { fundManagerList: updatedSelectedCheckboxes }));
        }
        if (activeTabKey === FieldNames.CATEGORY) {
            var updatedSelectedCheckboxes = aumsize === null || aumsize === void 0 ? void 0 : aumsize.categoryNameList;
            if (value === "all") {
                var filter = filtersData === null || filtersData === void 0 ? void 0 : filtersData.map(function (item) {
                    return item.filterId;
                });
                updatedSelectedCheckboxes = checked ? __spreadArray(["all"], __read(filter), false) : [];
            }
            else {
                if (checked) {
                    updatedSelectedCheckboxes === null || updatedSelectedCheckboxes === void 0 ? void 0 : updatedSelectedCheckboxes.push(value);
                }
                else {
                    updatedSelectedCheckboxes = (_c = aumsize === null || aumsize === void 0 ? void 0 : aumsize.categoryNameList) === null || _c === void 0 ? void 0 : _c.filter(function (item) { return item !== value; });
                }
            }
            setAumSize(__assign(__assign({}, aumsize), { categoryNameList: updatedSelectedCheckboxes }));
        }
    };
    var localFilterTabs = React.useMemo(function () { return [
        {
            title: "Category",
            eventKey: FieldNames.CATEGORY,
            tabContent: generateFiltersLoaderOrErrorUI(props.allFiltersLoader, filterDetailsCategory, function () {
                return generateCheckbox(localClientsList, aumsize === null || aumsize === void 0 ? void 0 : aumsize.categoryNameList, "Search by amc name", FieldNames.CATEGORY);
            }, true),
        },
        {
            title: "AMC Name",
            eventKey: FieldNames.AMCNAME,
            tabContent: generateFiltersLoaderOrErrorUI(props.allFiltersLoader, filterDetailsAmc, function () {
                return generateCheckbox(localClientsList, aumsize === null || aumsize === void 0 ? void 0 : aumsize.amcNameList, "Search by amc name", FieldNames.AMCNAME);
            }, true),
        },
        //   {
        //     title: "AUM Size (Cr)",
        //     eventKey: "aumSize",
        //     tabContent: generateFilterInputForClients(
        //       "conditionType",
        //       "Enter amount"
        //     ),
        //   },
        //   {
        //     title: "Return Expectations",
        //     eventKey: "returnExpectations",
        //     tabContent: generateFilterInputForClients(
        //       "returnExpectation",
        //       "Enter percentage"
        //     ),
        //   },
        //   {
        //     title: "Drawdown",
        //     eventKey: "drawDown",
        //     tabContent: generateFilterInputForClients(
        //       "drawdown",
        //       "Enter percentage"
        //     ),
        //   },
        //   {
        //     title: "Fund Manager",
        //     eventKey: FieldNames.FUNDMANAGER,
        //     tabContent: generateFiltersLoaderOrErrorUI(
        //       props.allFiltersLoader,
        //       filterDetailsFund,
        //       () =>
        //         generateCheckboxFiltersForClients(
        //           localClientsList,
        //           aumsize?.fundManagerList,
        //           "Search by manager name",
        //           FieldNames.FUNDMANAGER
        //         ),
        //       false
        //     ),
        //   },
        {
            title: "Fund Name",
            eventKey: FieldNames.FUND_NAME_CAP,
            tabContent: generateFiltersLoaderOrErrorUI(props.allFiltersLoader, filterListAIFFundName, function () {
                return generateCheckbox(localClientsList, aumsize === null || aumsize === void 0 ? void 0 : aumsize.fundNameList, "Search by amc name", FieldNames.FUND_NAME_CAP);
            }, true),
        },
    ]; }, [
        props.allFiltersLoader,
        localClientsList,
        aumsize,
        filterDetailsCategory,
        filterDetailsAmc,
        filterDetailsFund,
        filterListAIFFundName,
    ]);
    var localFilterTabsPms = React.useMemo(function () { return [
        {
            title: "AMC Name",
            eventKey: FieldNames.AMCNAME,
            tabContent: generateFiltersLoaderOrErrorUI(props.allFiltersLoader, filterDetailsAmc, function () {
                return generateCheckbox(localClientsList, aumsize === null || aumsize === void 0 ? void 0 : aumsize.amcNameList, "Search by amc name", FieldNames.AMCNAME);
            }, true),
        },
        //   {
        //     title: "AUM Size (Cr)",
        //     eventKey: "aumSize",
        //     tabContent: generateFilterInputForClients(
        //       "conditionType",
        //       "Enter amount"
        //     ),
        //   },
        //   {
        //     title: "Return Expectations",
        //     eventKey: "returnExpectations",
        //     tabContent: generateFilterInputForClients(
        //       "returnExpectation",
        //       "Enter percentage"
        //     ),
        //   },
        //   {
        //     title: "Drawdown",
        //     eventKey: "drawDown",
        //     tabContent: generateFilterInputForClients(
        //       "drawdown",
        //       "Enter percentage"
        //     ),
        //   },
        //   {
        //     title: "Fund Manager",
        //     eventKey: FieldNames.FUNDMANAGER,
        //     tabContent: generateFiltersLoaderOrErrorUI(
        //       props.allFiltersLoader,
        //       filterDetailsFund,
        //       () =>
        //         generateCheckboxFiltersForClients(
        //           localClientsList,
        //           aumsize?.fundManagerList,
        //           "Search by manager name",
        //           FieldNames.FUNDMANAGER
        //         ),
        //       false
        //     ),
        //   },
        {
            title: "Fund Name",
            eventKey: FieldNames.FUND_NAME_CAP,
            tabContent: generateFiltersLoaderOrErrorUI(props.allFiltersLoader, filterListFundName, function () {
                return generateCheckbox(localClientsList, aumsize === null || aumsize === void 0 ? void 0 : aumsize.fundNameList, "Search by amc name", FieldNames.FUND_NAME_CAP);
            }, true),
        },
    ]; }, [
        props.allFiltersLoader,
        localClientsList,
        aumsize,
        filterDetailsAmc,
        filterDetailsFund,
        filterListFundName,
    ]);
    var handleUpdateFiltersRespectiveToTab = function (data) {
        data;
        handleUpdateFilterTabsData(data);
    };
    var handleUpdateFilterTabsData = function (data) {
        setFilterTabs(function () { return data; });
    };
    var handleApplyFilters = function () {
        if (props === null || props === void 0 ? void 0 : props.handleApplyCallback) {
            props === null || props === void 0 ? void 0 : props.handleApplyCallback(aumsize);
        }
    };
    var handleUpdateLocalClientsListRespectiveToTab = function () {
        switch (activeTabKey) {
            case FieldNames.AMCNAME:
                setLocalClientsList(filterDetailsAmc);
                break;
            case FieldNames.FUNDMANAGER:
                setLocalClientsList(filterDetailsFund);
                break;
            case FieldNames.CATEGORY:
                setLocalClientsList(filterDetailsCategory);
                break;
            case FieldNames.FUND_NAME_CAP:
                var data = (props === null || props === void 0 ? void 0 : props.requestPayload) == ESubProductIds.AIF
                    ? filterListAIFFundName
                    : filterListFundName;
                setLocalClientsList(data);
                break;
            default:
                null;
        }
    };
    useEffect(function () {
        if (props.isAumSize) {
            setAumSize(__assign(__assign({}, aumsize), props.summaryData));
        }
        if (props.isShowFilterPopup === false) {
            props.setSummaryData(__assign({}, aumsize));
        }
        else {
            setAumSize(__assign(__assign({}, aumsize), props.summaryData));
            if (props.isClear) {
                props.setIsAumSize(false);
                props.setIsClear(false);
                setAumSize({
                    conditionType: {
                        conditionType: { label: "Above", value: "Above" },
                        conditionValue: "",
                    },
                    returnExpectation: {
                        returnExpectation: { label: "Above", value: "Above" },
                        conditionValue: "",
                    },
                    drawdown: {
                        drawdown: { label: "Above", value: "Above" },
                        conditionValue: "",
                    },
                    amcNameList: [],
                    fundManagerList: [],
                    categoryNameList: [],
                    fundNameList: [],
                });
                props.setSummaryData({
                    conditionType: {
                        conditionType: { label: "Above", value: "Above" },
                        conditionValue: "",
                    },
                    returnExpectation: {
                        returnExpectation: { label: "Above", value: "Above" },
                        conditionValue: "",
                    },
                    drawdown: {
                        drawdown: { label: "Above", value: "Above" },
                        conditionValue: "",
                    },
                    amcNameList: [],
                    fundManagerList: [],
                    categoryNameList: [],
                    fundNameList: [],
                });
            }
        }
    }, [
        props.isShowFilterPopup,
        props.isClear,
        props.isAumSize,
        props.filterLabels,
        props.setSummaryData,
    ]);
    React.useEffect(function () {
        if (props.requestPayload == ESubProductIds.AIF) {
            handleUpdateFiltersRespectiveToTab(localFilterTabs);
        }
        else {
            handleUpdateFiltersRespectiveToTab(localFilterTabsPms);
        }
    }, [
        localClientsList,
        aumsize,
        filterDetailsFund,
        filterDetailsAmc,
        filterDetailsCategory,
        filterListAIFFundName,
        props.requestPayload,
    ]);
    React.useEffect(function () {
        handleUpdateLocalClientsListRespectiveToTab();
    }, [activeTabKey]);
    useEffect(function () {
        var req = {
            category_code: String(props.requestPayload),
            fieldName: FieldNames.FUNDMANAGER,
            searchText: searchedClient,
        };
        if (!searchedClient && activeTabKey === FieldNames.FUNDMANAGER) {
            delete req.searchText;
            aifPmsDi.aifPms.getFilterDetails(req).then(function (res) {
                if (res) {
                    setLocalClientsList(res);
                }
            });
        }
        if (activeTabKey === FieldNames.FUNDMANAGER && req.searchText) {
            aifPmsDi.aifPms.getFilterDetails(req).then(function (res) {
                if (res) {
                    setLocalClientsList(res);
                }
            });
        }
    }, [searchedClient]);
    useEffect(function () {
        var fundManagerSearchText = localStorage.getItem("fundManagerSearchText");
        if (fundManagerSearchText) {
            setSearchedClient(fundManagerSearchText);
        }
    }, [props.isShowFilterPopup]);
    return (React.createElement("div", { className: "summary" },
        React.createElement(VerticalFilterTabs, { defaultActiveKey: activeTabKey, handleTabChange: function (key) { return setActiveTabKey(key); }, tabsList: filterTabs, cancelBtnCallback: (props === null || props === void 0 ? void 0 : props.handleCancelCallback) && (props === null || props === void 0 ? void 0 : props.handleCancelCallback), applyBtnCallback: function () { return handleApplyFilters(); }, clearAllBtnCallback: props === null || props === void 0 ? void 0 : props.handleClearAllCallback, isShowFilterHeader: false, parentClassName: "aif-pms-filter-tabs" })));
};
export default SummaryFiltersOrderbook;
